import { SentryCapture } from '@zz-common/sentry'

export default (Vue) => {
  try {
    Vue.component('ErrorBoundary', {
      data: () => ({ error: null }),
      errorCaptured(err, vm, info) {
        this.error = `${String(err.stack)}\n\nfound in ${String(info)} of component`
        SentryCapture(this.error, 1)
        return false
      },
      render(h) {
        if (this.error) {
          return null
        }
        return (this.$slots.default || [null])[0] || null
      }
    })
  } catch (err) {
    console.log(err)
    SentryCapture(err, 1)
  }
}
